var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, EventEmitter, Injector } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppConfigurationService } from '@app/shared/services/appconfigration.service';
var BrandMultiSelectComponent = /** @class */ (function (_super) {
    __extends(BrandMultiSelectComponent, _super);
    function BrandMultiSelectComponent(injector, _appConfigurationService) {
        var _this = _super.call(this, injector) || this;
        _this._appConfigurationService = _appConfigurationService;
        _this.name = 'BrandFilter';
        _this.selectedItemsChange = new EventEmitter();
        _this.placeholder = _this.l('Brand');
        _this.options = new Array();
        _this._selectedItems = [];
        return _this;
    }
    Object.defineProperty(BrandMultiSelectComponent.prototype, "selectedItems", {
        get: function () {
            return this._selectedItems;
        },
        set: function (file) {
            this._selectedItems = file || [];
            this.selectedItemsChange.emit(this._selectedItems);
        },
        enumerable: true,
        configurable: true
    });
    ;
    BrandMultiSelectComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._appConfigurationService.getBrands().subscribe(function (brands) { return _this.options = brands; });
    };
    BrandMultiSelectComponent.prototype.onPanelHide = function () {
        document.getElementById(this.name).focus();
    };
    return BrandMultiSelectComponent;
}(AppComponentBase));
export { BrandMultiSelectComponent };
